import wixLocation from 'wix-location';
var x=0;
var y=0;
var z=0;


$w.onReady(function () {
	console.log(wixLocation.query);
	$w("#club").value = wixLocation.query["club"];
});


export function Drive_change(event, $w) {
	if($w("#Drive").value==="ללא"){z=0;}
	else {z=170;}
	$w("#price").value=(x+y+z);
} 


export function Night_change(event, $w) {
	if($w("#Night").value==="ללא"){x=0;}
	else if ($w("#Night").value==="") {x=0;}
	else if ($w("#RoomSize").value==="4") {x=500;}
	else if ($w("#RoomSize").value==="3") {x=550;}
	else if ($w("#RoomSize").value==="2") {x=600;}
	else if ($w("#RoomSize").value==="0") {$w("#Night").value="ללא";}
	$w("#price").value=(x+y+z);
	
}

export function Hotel_change(event, $w) {
	if($w("#Hotel").value==="צמיד"){;
	x=0;
	z=0;
	y=800;
	$w("#price").value=x+y+z;
	
	$w("#RoomSize").value="0";
	$w("#Drive").value="ללא";
	$w("#Night").value="ללא";
	DISshowP();
	} else {
		$w("#RoomSize").enable();
		$w("#p1").enable();$w("#input18").enable();$w("#input5").enable();
		$w("#input19").enable();$w("#input20").enable();$w("#input21").enable();
		$w("#input22").enable();$w("#input23").enable();$w("#input24").enable();
		
		RoomSize_change(event,$w) ;
	} 
}

export function RoomSize_change(event, $w) {
Night_change(event, $w);
if($w("#Hotel").value==="מגיק סאנרייז"){
	if ($w("#RoomSize").value==="2") {
		y=1899;
	} else if  ($w("#RoomSize").value==="3") {
		y=1649;
	} else if  ($w("#RoomSize").value==="4") {
		y=1549;
	} else if  ($w("#RoomSize").value==="5") {
		y=1499;	
	} else  {
		$w("#RoomSize").value="";
	} 
} else if ($w("#Hotel").value==="בית הארחה"){
	if ($w("#RoomSize").value==="2") {
		y=1749;
	} else if  ($w("#RoomSize").value==="3") {
		y=1499;
	} else if  ($w("#RoomSize").value==="4") {
		y=1449;
	} else  {
		$w("#RoomSize").value="";
	} 
}
$w("#price").value=(x+y+z);
}



export function price_change(event, $w) {
	$w("#textP").show();
}

function DISshowP()
{
	$w('#p1').disable();
	$w("#input18").disable();
	$w("#input5").disable();
	$w("#input19").disable();
	$w("#input20").disable();
	$w("#input21").disable();
	$w("#input22").disable();
	$w("#input23").disable();
	$w("#input24").disable();
	$w("#RoomSize").disable();
	
}






